var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{ref:"dialog",attrs:{"title":_vm.result.question}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.result.answer)}})])}
var staticRenderFns = []

export { render, staticRenderFns }